// src/components/HomeHero.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

import videoSmMd from '../assets/pick/1103(1).mp4';
import videoLg from '../assets/pick/1103.mp4';

const HomeHero = () => {
    const { t } = useTranslation('hero');

    return (
        <section className="relative sm:min-h-screen w-full overflow-hidden">
            {/* Mobile & Tablet Video */}
            <video
                className="absolute inset-0 w-full h-full object-cover lg:hidden"
                autoPlay
                loop
                muted
                playsInline
                poster=""
            >
                <source src={videoSmMd} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            {/* Desktop Video */}
            <video
                className="absolute inset-0 w-full h-full object-cover hidden lg:block"
                autoPlay
                loop
                muted
                playsInline
                poster=""
            >
                <source src={videoLg} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            {/* Premium Dark Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black/80"></div>

            {/* Hero Content */}
            <div className="relative z-10 flex flex-col items-center justify-center min-h-screen text-center px-6 sm:px-8 lg:px-16">
                {/* Main Title */}
                <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold tracking-tighter text-white leading-tight">
                    <span className="block bg-gradient-to-r from-cyan-400 via-blue-500 to-teal-400 bg-clip-text text-transparent drop-shadow-2xl">
                        {t('title.line1')}
                    </span>
                    <span className="block text-6xl sm:text-7xl md:text-8xl lg:text-9xl text-amber-400 mt-2 tracking-wide">
                        {t('title.line2')}
                    </span>
                    <span className="block text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-emerald-300 font-light italic mt-3">
                        {t('title.line3')}
                    </span>
                </h1>

                {/* Subtitle */}
                <p className="mt-8 text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light text-gray-100 max-w-5xl mx-auto leading-relaxed opacity-95">
                    {t('subtitle')}
                    <span className="text-amber-300 font-medium"> {t('subtitle2')}</span>
                </p>

                {/* CTA Button */}
                <a
                    href="/tour"
                    className="mt-10 px-8 py-3.5 bg-gradient-to-r from-cyan-500 via-blue-600 to-emerald-600 text-white text-lg font-bold uppercase tracking-wider rounded-full shadow-xl hover:shadow-cyan-500/50 transform hover:scale-105 transition-all duration-400 hover:from-cyan-400 hover:to-emerald-500 focus:outline-none focus:ring-4 focus:ring-cyan-400/40"
                >
                    {t('cta')}
                </a>

                {/* Trust Line */}
                <p className="mt-12 text-sm sm:text-lg text-gray-300 font-medium tracking-wide">
                    {t('trust')}
                </p>

                {/* Scroll Indicator */}
                <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
                    <svg className="w-8 h-8 text-white opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                    </svg>
                </div>
            </div>
        </section>
    );
};

export default HomeHero;